import { render, staticRenderFns } from "./datisocietari.vue?vue&type=template&id=64aecb85"
import script from "./datisocietari.vue?vue&type=script&lang=js"
export * from "./datisocietari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports